import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `<span enTooltip title="{{ os }}">{{ os }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OsNameComponent extends DataWidgetComponent implements OnInit {
  @Input()
  data: MobileAppPtiRanking;

  os: string;

  ngOnInit(): void {
    super.ngOnInit();
    this.os = this.getOs();
  }

  getOs() {
    const osValue = this.data[this.key];
    switch (this.data[this.key]) {
      case 'roku':
        return 'Roku';
      case 'firetv':
        return 'Fire TV';
      case 'fireos':
        return 'Fire TV';
      case 'android':
        return 'Android';
      case 'ios':
        return 'iOS';
      case 'tvos':
        return 'tvOS';
      case 'samsung':
        return 'Samsung';
      case 'lgtv':
        return 'LG TV';
      default:
        return osValue;
    }
  }
}
